"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const utils_1 = __importDefault(require("@nexys/utils"));
const ui_1 = require("./ui");
const order_utils_1 = require("./utils/order-utils");
const filter_utils_1 = require("./utils/filter-utils");
const pagination_utils_1 = require("./utils/pagination-utils");
const list_super_partials_1 = require("./list-super-partials");
const ListSuper = ({ HeaderUnit, FilterUnit, OrderController, ColCell, GlobalSearch, NoRow, Row, ListWrapper, ListContainer, ListHeader, ListBody, RecordInfo, Pagination }) => function InnerListSuper(props) {
    const { def, config = {}, asyncData, CustomListContainer, CustomListItem } = props;
    const filtersFromProps = config.filters
        ? filter_utils_1.transformFilterPropToStateFilter(def, config.filters)
        : undefined;
    const [state, dispatch] = react_1.useReducer(list_super_partials_1.listSuperReducer, list_super_partials_1.getInitialState(def, props.data, config.sortAttribute, config.sortDescAsc, filtersFromProps));
    const { filters, pageIdx, sortAttribute, sortDescAsc, data, numberOfTotalRows, loading } = state;
    const nPerPage = config.nPerPage || props.nPerPage || 25;
    if (props.nPerPage) {
        console.warn('The use of nPerPage in props is deprecated. Add nPerPage to the config object prop.');
    }
    const fetchData = react_1.useCallback((config) => {
        if (asyncData) {
            dispatch({ type: list_super_partials_1.ActionType.FETCH_DATA_REQUEST });
            asyncData({
                nPerPage,
                pageIdx: config && config.pageIdx ? config.pageIdx : pageIdx,
                filters: config && config.filters ? config.filters : filters,
                sort: {
                    attribute: config && config.sortAttribute
                        ? config.sortAttribute
                        : sortAttribute,
                    descAsc: config && typeof config.sortDescAsc !== 'undefined'
                        ? config.sortDescAsc
                        : sortDescAsc
                }
            }).then(res => {
                dispatch({
                    type: list_super_partials_1.ActionType.FETCH_DATA_SUCCESS,
                    payload: { data: res.data, numberOfTotalRows: res.meta.n }
                });
            });
        }
    }, [asyncData, filters, nPerPage, pageIdx, sortAttribute, sortDescAsc]);
    react_1.useEffect(() => {
        fetchData();
    }, [asyncData, fetchData]);
    const handleFilterChange = (v) => {
        const newFilters = filter_utils_1.updateFilters(filters, v);
        // when a filter is applied, the page index is reset
        const pageIdx = 1;
        const config = {
            filters: newFilters,
            pageIdx
        };
        dispatch({
            type: list_super_partials_1.ActionType.FILTER_CHANGE,
            payload: config
        });
        fetchData(config);
    };
    const handleFilterReset = (name) => {
        const newFilters = Object.assign({}, filters);
        delete newFilters[name];
        // when a filter is applied, the page index is reset
        const pageIdx = 1;
        const config = {
            filters: newFilters,
            pageIdx
        };
        dispatch({ type: list_super_partials_1.ActionType.FILTER_CHANGE, payload: config });
        fetchData(config);
    };
    /**
     * defines order to apply
     * @param  {[type]} name    attribute/column
     * @param  {[type]} descAsc true/false - asc or desc. if null, will toggle
     * @return {[type]}         [description]
     * todo: allow custom ordering
     */
    const setOrder = (name, descAsc = null) => {
        if (descAsc === null) {
            descAsc = !sortDescAsc;
        }
        const config = { sortDescAsc: descAsc, sortAttribute: name, pageIdx: 1 };
        dispatch({
            type: list_super_partials_1.ActionType.ORDER_CHANGE,
            payload: config
        });
    };
    const changePage = (pageIdx) => {
        // todo block beyond max page
        if (pageIdx > 0) {
            const config = { pageIdx };
            dispatch({ type: list_super_partials_1.ActionType.PAGE_CHANGE, payload: config });
        }
    };
    const isSort = (h) => {
        return ((typeof h.sort === 'boolean' && h.sort === true) ||
            typeof h.sort === 'object');
    };
    const renderHeaders = () => {
        return def.map((h, i) => {
            const order = isSort(h) ? (react_1.default.createElement(OrderController, { descAsc: sortAttribute === h.name ? sortDescAsc : null, onClick: () => setOrder(h.name) })) : null;
            const filter = (react_1.default.createElement(FilterUnit, { key: i, filters: filters, name: h.name, filter: h.filter, onChange: handleFilterChange, onReset: handleFilterReset, debounceWait: config.debounceWait }));
            return (react_1.default.createElement(HeaderUnit, { key: i },
                h.label || '',
                " ",
                order,
                " ",
                filter));
        });
    };
    const renderBody = (data) => (react_1.default.createElement(react_1.default.Fragment, null, data.map((row, i) => (react_1.default.createElement(react_1.default.Fragment, { key: i }, CustomListItem ? (react_1.default.createElement(react_1.default.Fragment, null, CustomListContainer ? (CustomListItem(row)) : (react_1.default.createElement(Row, null,
        react_1.default.createElement(ColCell, { colSpan: def.length, style: {
                paddingLeft: 0,
                paddingRight: 0,
                borderBottom: 0
            } }, CustomListItem(row)))))) : (react_1.default.createElement(Row, null, def.map((h, j) => (react_1.default.createElement(ColCell, { key: j }, h.render
        ? h.render(row)
        : utils_1.default.ds.get(h.name.toString(), row)))))))))));
    const renderLoader = () => (react_1.default.createElement(Row, null,
        react_1.default.createElement(ColCell, { colSpan: def.length },
            react_1.default.createElement(ui_1.Loader, null))));
    let fData = [];
    let fpData = [];
    let n = 0;
    if (!asyncData) {
        fData = filter_utils_1.applyFilter(data, filters);
        n = fData.length;
        fpData = sortAttribute
            ? pagination_utils_1.withPagination(order_utils_1.order(fData, order_utils_1.getSort(def, sortAttribute), sortDescAsc), pageIdx, nPerPage)
            : pagination_utils_1.withPagination(fData, pageIdx, nPerPage);
    }
    else {
        n = numberOfTotalRows;
    }
    const showPagination = typeof config.pagination !== 'undefined' ? config.pagination : true;
    const showRecordInfo = typeof config.recordInfo !== 'undefined' ? config.recordInfo : true;
    return (react_1.default.createElement(ListWrapper, null,
        react_1.default.createElement(GlobalSearch, { search: config.search, onChange: handleFilterChange, filters: filters, debounceWait: config.debounceWait }),
        CustomListContainer ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ListContainer, null,
                react_1.default.createElement(ListHeader, null,
                    react_1.default.createElement(Row, null, renderHeaders()))),
            CustomListContainer(renderBody(asyncData ? data : fpData)))) : (react_1.default.createElement(ListContainer, { maxHeight: config.maxHeight, stickyHeader: config.stickyHeader },
            react_1.default.createElement(ListHeader, null,
                react_1.default.createElement(Row, null, renderHeaders())),
            react_1.default.createElement(ListBody, null, loading ? renderLoader() : renderBody(asyncData ? data : fpData)))),
        showRecordInfo && (react_1.default.createElement(RecordInfo, { n: n, idx: pageIdx, nPerPage: nPerPage })),
        showPagination && n > nPerPage && (react_1.default.createElement(Pagination, { n: n, nPerPage: nPerPage, idx: pageIdx, onClick: changePage })),
        !loading && react_1.default.createElement(NoRow, { n: n })));
};
exports.default = ListSuper;
